import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginGridBgComponent } from './login-grid-bg.component';

/** Shares the magnetic-grid canvas so both the sign-in page and the public
 *  landing can render <app-login-grid-bg>. */
@NgModule({
	declarations: [LoginGridBgComponent],
	imports: [CommonModule],
	exports: [LoginGridBgComponent],
})
export class LoginGridBgModule {}
